import API from '../Common/Endpoint/serviceConstrants';
import axiosInstance from '../Common/Axios/axiosInstance';

export const callClientProductMappingbyIdGetApi = async (payload) => {
    
    const { data = {} } = await axiosInstance.get(`${API.getClientProductMappingbyId}?clientId=${payload}&enable=1`);
    return data;
  };
